export const FourZeroFour = ({
    testId = 'img-unplugged',
    fill,
    width = 613,
    height = 196,
}: {
    testId?: string;
    fill?: string;
    width?: number;
    height?: number;
}) => (
    <svg
        role="img"
        aria-labelledby="altTextUnplugged"
        data-testid={testId}
        width="613"
        height="196"
        fill={fill ?? 'none'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 613 196"
        style={{ width, height }}
    >
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <title id="altTextUnplugged">Error</title>
        <circle
            cx="120.738"
            cy="26.563"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="120.738"
            cy="169.438"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="25.488"
            cy="121.813"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="168.363"
            cy="121.813"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="230.275"
            cy="98"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="373.15"
            cy="98"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="301.712"
            cy="26.563"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="301.712"
            cy="169.438"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M1.675 121.813C1.675 108.661 12.336 98 25.488 98h142.875c13.151 0 23.812 10.661 23.812 23.813 0 13.151-10.661 23.812-23.812 23.812H25.488c-13.152 0-23.813-10.661-23.813-23.812Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M120.738 193.25c-13.152 0-23.813-10.661-23.813-23.812V26.563c0-13.152 10.661-23.813 23.813-23.813 13.151 0 23.812 10.661 23.812 23.813v142.875c0 13.151-10.661 23.812-23.812 23.812Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M8.988 138.475c-9.3-9.299-9.3-24.376 0-33.676l94.736-94.736c9.3-9.3 24.377-9.3 33.676 0 9.3 9.3 9.299 24.377 0 33.676l-94.736 94.736c-9.3 9.3-24.377 9.3-33.676 0Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="539.837"
            cy="26.563"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="539.837"
            cy="169.438"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="444.587"
            cy="121.813"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="587.462"
            cy="121.813"
            r="23.813"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M420.775 121.813c0-13.152 10.661-23.813 23.812-23.813h142.875c13.152 0 23.813 10.661 23.813 23.813 0 13.151-10.661 23.812-23.813 23.812H444.587c-13.151 0-23.812-10.661-23.812-23.812Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M539.837 193.25c-13.151 0-23.812-10.661-23.812-23.812V26.563c0-13.152 10.661-23.813 23.812-23.813 13.152 0 23.813 10.661 23.813 23.813v142.875c0 13.151-10.661 23.812-23.813 23.812Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            d="M428.088 138.475c-9.299-9.299-9.299-24.376 0-33.676l94.736-94.736c9.3-9.3 24.377-9.3 33.676 0 9.3 9.3 9.3 24.377 0 33.676l-94.736 94.736c-9.299 9.3-24.377 9.3-33.676 0Z"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="301.712"
            cy="98"
            r="95.25"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <circle
            cx="301.712"
            cy="98"
            r="47.625"
            stroke="#667085"
            strokeWidth="2.381"
        />
        <path
            stroke="#667085"
            strokeWidth="2.381"
            d="M.484 1.559h610.791M.484 194.441h610.791"
        />
    </svg>
);
